import { render } from "./FooterInfo.vue?vue&type=template&id=153ba2f1"
import script from "./FooterInfo.vue?vue&type=script&lang=js"
export * from "./FooterInfo.vue?vue&type=script&lang=js"

import "./FooterInfo.vue?vue&type=style&index=0&id=153ba2f1&lang=scss"

import exportComponent from "C:\\Users\\Kyler\\OneDrive\\Website\\website2022\\development\\kylerherrera-2022\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__